module.exports = __webpack_public_path__ + "img/appicon.7b76bdf5.png";